// extracted by mini-css-extract-plugin
export default {"hideArrows":"plain-input-currency_hideArrows__rGhXv","placeHolderShimmer":"plain-input-currency_placeHolderShimmer__G0zg7"};